module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAYAAAC5Sw6hAAAAAXNSR0IArs4c6QAAAIRJREFUKFNjZGBgYPhf7STP2LrvIYhNKoDpZQQxvjMwnGJk+h/G2bz/ICkGfa91tP//j3EVJwODGSNII0yAFMPQ9YANItUwbBbDDSLWMFyuRzGIkGH4ggDDIFyGEQpHrAahGwZOIv8YV+GLDJwGIRsGYhOKUbwGgQ2rcXBgYGT8TyiNAQAg1XzmziGlCAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/icon_zhankai.png
// module id = jA81
// module chunks = 0